import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d1c5d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "small-phase-item tw-flex tw-flex-col tw-h-full tw-w-full tw-gap-[10px]" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-items-center tw-w-full tw-box-border tw-gap-2 tw-flex-wrap"
}

import { computed, onMounted, reactive, watch } from "vue";
import { useStore } from "vuex";

import Card from "@/core/components/ui/general/Card.vue";
import Text from "@/core/components/ui/general/Text.vue";
import PhaseTitle from "@/modules/project/components/common/PhaseTitle.vue";
import ContractorItem from "@/core/uni-components/ContractorItem.vue";
import estimateConstants from "@/core/constants/estimate";
import CurrencyFilter from "@/filters/currency.filter";
import { JOB_TEMPLATE_STORE } from "@/store/modules/job-template";
import workstation, { WORKSTATION } from "@/store/modules/workstation";


const __default__ = {
  name: "SmallPhaseItem",
};

interface phaseSummaryDataType {
  label?: string;
  data: any;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ["phaseIndex", "estimate", "isHistoricalProject"],
  setup(__props) {

const store = useStore();

const props = __props;

const state = reactive({
  normalizePhaseSummaryData: [] as phaseSummaryDataType[],
});

const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const contractorDetails = computed(() => {
  return {
    userName: props?.estimate?.user?.firstName,
    workstationName: props?.estimate?.workStation?.name,
    profileImage: props?.estimate?.workStation?.profileImage,
  };
});
const estimateForm = computed(
  () => store.getters[`${JOB_TEMPLATE_STORE}/estimateForm`]
);

const isLabour = computed(() => {
  return props.estimate?.stageType === "labour";
});

const onInitialize = () => {
  if (props.estimate) {
    let phaseSummaryData: phaseSummaryDataType[];

    if (isLabour.value) {
      phaseSummaryData = [
        {
          label:
            props.estimate?.projectStageTasks.length > 1 ? "tasks" : "task",
          data: props.estimate?.projectStageTasks.length,
        },
        {
          label: getDurationType(props.estimate.durationType),
          data: props.estimate?.totalDuration,
        },
        {
          data: CurrencyFilter.formatToCurrency(props.estimate?.subTotal),
        },
        {
          label: getEstimateProperties.value > 1 ? "Properties" : "Property",
          data: getEstimateProperties.value,
        },
      ];
    } else {
      phaseSummaryData = [
        {
          label:
            props.estimate?.projectStageTasks.length > 1 ? "items" : "item",
          data: props.estimate?.projectStageTasks.length,
        },
        {
          data: CurrencyFilter.formatToCurrency(props.estimate?.subTotal),
        },
        {
          label: getEstimateProperties.value > 1 ? "Properties" : "Property",
          data: getEstimateProperties.value,
        },
      ];
    }

    state.normalizePhaseSummaryData = phaseSummaryData;
  }
};

const getEstimateProperties = computed(() => {
  const materialProperties =
    props.estimate.estimationPhaseProperties &&
    props.estimate.estimationPhaseProperties.length
      ? props.estimate.estimationPhaseProperties.length
      : 0;

  let labourProperties = 0;
  let labourPropertiesArray = [] as any;

  if (props.estimate.projectStageTasks && isLabour.value) {
    props.estimate.projectStageTasks.forEach((task: any) => {
      if (
        task.estimationPhaseTasksProperties &&
        task.estimationPhaseTasksProperties.length
      ) {
        task.estimationPhaseTasksProperties.forEach((property: any) => {
          if (!labourPropertiesArray.includes(property.propertyId)) {
            labourPropertiesArray.push(property.propertyId);
          }
        });
      }
    });
  }

  labourProperties = labourPropertiesArray.length;

  return isLabour.value ? labourProperties : materialProperties;
});
const getDurationType = (durationType: any) => {
  if (durationType === estimateConstants.DAYS) {
    return "Day(s)";
  }
  if (durationType === estimateConstants.WEEKS) {
    return "Week(s)";
  }
  if (durationType === estimateConstants.MONTHS) {
    return "Month(s)";
  }
  return "";
};

watch(
  () => props.estimate,
  (newValue, oldValue) => {
    onInitialize();
  },
  { deep: true, immediate: true }
);

onMounted(async () => {
  await onInitialize();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Card, { class: "!tw-p-4 !tw-box-border !tw-shadow-none !tw-bg-[#F6F6F8] tw-rounded-[10px] tw-max-h-[150px]" }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(PhaseTitle, {
          title: __props.estimate.name,
          phaseNumber: __props.phaseIndex + 1,
          estimate: __props.estimate,
          textColor: __props.estimate?.color || '#4A92E5'
        }, null, 8, ["title", "phaseNumber", "estimate", "textColor"]),
        (!__props.isHistoricalProject)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.normalizePhaseSummaryData, (summary, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "small-phase-item__item tw-pr-4 tw-flex tw-gap-2 tw-items-start"
                }, [
                  _createVNode(Text, {
                    variant: "span",
                    textColor: "rgba(12, 15, 74, 0.5)"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(summary.data), 1)
                    ]),
                    _: 2
                  }, 1024),
                  (summary.label)
                    ? (_openBlock(), _createBlock(Text, {
                        key: 0,
                        variant: "span",
                        textWeight: "400",
                        textColor: "rgba(12, 15, 74, 0.5)"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(summary?.label), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})